import React from 'react';
import { Box, Text, Flex, Button, Badge } from '@chakra-ui/react';
import { useUpdateDecisionMutation } from "../app/api";
import { useSelector } from 'react-redux';
import { path } from "ramda";

export const TopCriterion = ({ items, items2, decision_id, order_nr, next_to_show,
  show_until, done_item, data_input, next_btn_visible, is_last }) => {

  const [moveForward] = useUpdateDecisionMutation();
  const texts = useSelector(path(["ui", "ui_texts"]));

  // items  = criteria text rows (from multiple_input, have value_text + id)
  // items2 = weighting rows (value_number = weight, input_id = criterion_id)

  // Average weight per criterion across all participants
  const weightSums = {};
  const weightCounts = {};
  (items2 || []).forEach(row => {
    if (row.input_id != null && row.value_number != null) {
      const key = String(row.input_id);
      weightSums[key] = (weightSums[key] || 0) + row.value_number;
      weightCounts[key] = (weightCounts[key] || 0) + 1;
    }
  });

  const ranked = items
    .filter(item => item.value_text)
    .map(item => {
      const key = String(item.id);
      const avg = weightCounts[key]
        ? weightSums[key] / weightCounts[key]
        : 0;
      return { id: item.id, text: item.value_text, avg };
    })
    .sort((a, b) => b.avg - a.avg);

  const topAvg = ranked[0]?.avg ?? 0;
  const winners = ranked.filter(x => x.avg === topAvg && topAvg > 0);

  const hide_next_btn = (done_item === null || data_input == null)
    ? (show_until > order_nr)
    : !next_btn_visible;

  return (
    <Box>
      {winners.length === 0 ? (
        <Text color="gray.400" fontSize="sm">{texts.no_votes || "No weights yet"}</Text>
      ) : winners.length === 1 ? (
        <Box>
          <Text fontSize="xl" fontWeight="bold">{winners[0].text}</Text>
        </Box>
      ) : (
        <Box>
          <Badge colorScheme="orange" mb={2}>{texts.tie || "Tie"}</Badge>
          {winners.map(w => (
            <Box key={w.id} mb={1}>
              <Text fontSize="xl" fontWeight="bold">{w.text}</Text>
            </Box>
          ))}
        </Box>
      )}
      {(is_last || hide_next_btn) ? null : (
        <Flex mt={3} gap={2}>
          <Button size="md" colorScheme="blue" onClick={() => {
            moveForward({
              id: decision_id,
              done: order_nr,
              show_until: next_to_show
            });
          }}>
            {texts.next}
          </Button>
        </Flex>
      )}
    </Box>
  );
};
